/* eslint-disable no-console */

/**
 * Creates a Forage card element for EBT card tokenization
 *
 * @param {Object} params - Configuration object
 * @param {string} params.elementID - The ID of the DOM element where the card input will be mounted
 * @param {Object} params.forage - The initialized Forage instance for card tokenization
 * @param {Function} [params.onReady] - Optional callback fired when the element is ready
 * @param {Function} [params.onChange] - Optional callback fired when validation state changes
 *
 * @returns {Promise<Object>} Promise that resolves with the mounted Forage card element
 *
 * @throws {Error} When Forage instance is not provided
 * @throws {Error} When the specified DOM container is not found
 * @throws {Error} When element creation or mounting fails
 */
export const createCardElement = ({ elementID, forage, onChange, onReady }) => {
    if (!forage) {
        return Promise.reject(new Error('Forage instance not initialized'));
    }

    return new Promise((resolve, reject) => {
        try {
            const container = document.getElementById(elementID);

            if (!container) {
                reject(new Error(`Card element container not found: ${elementID}`));
                return;
            }

            const element = forage.create('tokenize_card');

            element.mount(elementID);

            // Set up event listeners
            element.on('ready', () => {
                onReady?.(element);
                resolve(element);
            });

            element.on('change', (event) => {
                onChange?.(event);
            });
        } catch (error) {
            reject(error);
        }
    });
};

/**
 * Destroys the Forage card element
 */
export const destroyCardElement = (cardElement) => {
    if (!cardElement) return;
    cardElement.destroy();
};
